export class MyDiary {
  constructor(
    public id:any,
    public approverUserId: any,
    public entryDate: any,
    public assignmentId: any,
    public clientId: any,
    public locationId: any,
    public forFy: any,
    public taskId: any,
    public inTime: any,
    public outTime: any,
    
    public noOfHours: any,
    public extraHours: any,
    public debitedHours: any,
    public creditedHours: any,

    public travellingFrom: any,
    public distanceFromOffice: any,
    public chargeableToClient: any,
   
    public mode: any,
   
    public rate: any,
    public amount: any,
    public workPerformed: any
  ) { }
  
    // constructor(
    //     public amount: any,
    //     public approver: any,
    //     public assignment: any,
    //     public chargeableToClient: any,
    //     public client: any,
    //     public creditedHours: any,
    //     public debitedHours: any,
    //     public distanceFromOffice: any,
    //     public employeeUser: any,
    //     public entryDate: any,
    //     public extraHours: any,
    //     public inTimeHour: any,
    //     public inTimeMin: any,
    //     public location: any,
    //     public mode: any,
    //     public noOfHours: any,
    //     public outTimeHour: any,
    //     public outTimeMin: any,
    //     public rate: any,
    //     public task: any,
    //     public travellingFrom: any,
    //     public workPerformed: any,
    //     public forFy: any
    //   ) { }
}